module.exports = __webpack_public_path__ + "static/media/TermsAndConditions_sq.8308e647.md";